import { render, staticRenderFns } from "./UpdatePasswordAdmin.vue?vue&type=template&id=08bb33e4&scoped=true"
import script from "./UpdatePasswordAdmin.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb33e4",
  null
  
)

export default component.exports